import { formatRentalDate, formatRentalDateRange } from './dateUtils';
import { isRentalEnded, isRentalPaid } from './rentalPayments';

export { formatRentalDate, formatRentalDateRange };

export function isRentalReviewEligible(rental) {
  if (!rental) return false;
  if (rental.status === 'completed') return true;
  return isRentalPaid(rental) && isRentalEnded(rental);
}

export function isPublicRentalHistoryEntry(rental) {
  if (!rental) return false;
  if (rental.status === 'denied' || rental.status === 'pending') return false;
  if (rental.status === 'completed') return true;
  return isRentalPaid(rental) && isRentalEnded(rental);
}

export function renderStarRating(rating = 0) {
  const rounded = Math.round(Number(rating) || 0);
  return `${'★'.repeat(rounded)}${'☆'.repeat(5 - rounded)}`;
}

export function findReviewForRental(reviews, rentalId, type) {
  return reviews.find((review) => review.rentalId === rentalId && review.type === type);
}

export function hasUserReviewedRental(reviews, rentalId, userId, type) {
  return reviews.some(
    (review) =>
      review.rentalId === rentalId &&
      review.type === type &&
      review.reviewerId === userId
  );
}